<div class="outer-wrapper">
  <div class="inner-wrapper" [class.expanded]="expanded" *ngIf="text">
    <p #textContainer class="text" [class.preserve-line-breaks]="preserveLineBreaks">{{text}}</p>
    <ion-button fill="clear" size="small" *ngIf="isOverflowing" (click)="toggleView()">
      {{ expanded ? ('VIEW_LESS' | translate) : ('VIEW_MORE' | translate)}}
      <ion-icon slot="end" [name]="expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
    </ion-button>
  </div>
</div>
